import React from "react"
import { SvgIcon, SvgIconProps } from "@material-ui/core"

export default function Docket(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 50 56">
      <path d="M48.6 41H.6V8.6h24.7V1h1.6v7.6h14.4V5.4h1.6v3.2h5.7v23.2h.8v1.6h-.8V41zM2.2 39.4H47v-6h-4.1v2.8h-1.6v-2.8h-21v-1.6h21V18.2H26.9v6.6h-1.6v-6.6H9.5v-1.6h15.8v-6.4H2.2v29.2zm40.7-7.6H47V10.2h-4.1v6.4h1.6v1.6h-1.6v13.6zm-16-15.2h14.4v-6.4H26.9v6.4z" />
      <text transform="translate(.912 55)" fontSize="11.6" fontFamily="Helvetica" fill="currentColor">
        DOCKET
      </text>
    </SvgIcon>
  )
}
